// LedgerFlex theme JS
(function(){
  'use strict';

  // Scroll reveal
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if (e.isIntersecting){
        e.target.classList.add('in');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
  document.querySelectorAll('.reveal').forEach(function(el){ io.observe(el); });

  // Number counter
  var counter = document.getElementById('counter');
  if (counter){
    var target = parseInt(counter.getAttribute('data-target') || '12847', 10);
    var dur = 1800;
    var start = performance.now();
    (function tick(now){
      var p = Math.min(1, (now - start) / dur);
      var e = 1 - Math.pow(1 - p, 3);
      var v = Math.round(target * e);
      counter.textContent = '$' + v.toLocaleString();
      if (p < 1) requestAnimationFrame(tick);
    })(performance.now());
  }

  // Product filter chips
  var chips = document.querySelectorAll('.chip');
  var products = document.querySelectorAll('.prod-grid .prod');
  chips.forEach(function(chip){
    chip.addEventListener('click', function(){
      chips.forEach(function(c){ c.classList.remove('active'); });
      chip.classList.add('active');
      var tag = chip.getAttribute('data-tag');
      products.forEach(function(p){
        if (tag === 'all' || !tag){
          p.classList.remove('hidden');
        } else {
          var tags = (p.getAttribute('data-tags') || '').toLowerCase();
          if (tags.indexOf(tag) !== -1){
            p.classList.remove('hidden');
          } else {
            p.classList.add('hidden');
          }
        }
      });
    });
  });

  // Cart count refresh on page load (fetch from Shopify)
  var cartCount = document.getElementById('cart-count');
  if (cartCount && window.fetch){
    fetch('/cart.js').then(function(r){ return r.json(); }).then(function(c){
      cartCount.textContent = c.item_count;
    }).catch(function(){});
  }
})();
